import { SalaryType } from "../../../../../../shared/util/salary/SalaryType";

// US fallback used when OneGraph (SAL-7306) bounds are unavailable. Typed
// as Record<SalaryType, ...> so adding a SalaryType member without a
// matching fallback row is a compile error rather than a runtime undefined.
export const payBounds: Record<SalaryType, readonly [number, number]> = {
  [SalaryType.Hourly]: [2, 500],
  [SalaryType.Daily]: [30, 4000],
  [SalaryType.Weekly]: [40, 20000],
  [SalaryType.Monthly]: [100, 90000],
  [SalaryType.Yearly]: [2000, 1000000],
};

export type PayBoundsKey = SalaryType;
export type PayBoundsMap = Partial<Record<PayBoundsKey, readonly [number, number]>>;

export function getPayBounds(
  salaryType: PayBoundsKey,
  dynamicPayBounds?: PayBoundsMap,
): readonly [number, number] {
  return dynamicPayBounds?.[salaryType] ?? payBounds[salaryType];
}
